import request from '@/utils/request'

export function getItem(data) {
  return request({
    url: '/Coach/Get',
    method: 'post',
    data: { id: data },
  })
}

export function fetchList(data) {
  return request({
    url: '/Coach/List',
    method: 'post',
    data,
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/Coach/Create',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function updateItem(data) {
  // console.log('coachUpdate', data)

  return request({
    url: '/Coach/update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function deleteItem(data) {
  return request({
    url: '/Coach/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAuthCenter() {
  return request({
    url: '/Coach/AuthCenterList',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}

export function listSubFolder() {
  return request({
    url: '/Coach/ListSubFolder',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}

export function listCoachFiles(data) {
  return request({
    url: '/Coach/ListCoachFiles',
    method: 'post',
    data,
  })
}

export function uploadCoachFile(data) {
  return request({
    url: '/Coach/UploadCoachFile',
    method: 'post',
    data,
  })
}

export function deleteDocument(id) {
  return request({
    url: '/Coach/DeleteDocument',
    method: 'delete',
    data: { id },
  })
}

export function CoachListForReport(data) {
  return request({
    url: '/Coach/CoachListForReport',
    method: 'post',
    data,
  })
}
export function listCoachCommission(data) {
  return request({
    url: '/Coach/ListCoachCommission',
    method: 'post',
    data,
  })
}
export function updateCoachCommissionSchema(data) {
  return request({
    url: '/Coach/UpdateCoachCommissionSchema',
    method: 'post',
    data,
  })
}
